(function () {
  var STATUS_LABELS = {
    initial: '準備查詢',
    loading: '正在查詢',
    not_found: '未能找到訂單',
    unfulfilled: '尚未寄出',
    collected: '已交送貨公司',
    in_transit: '運送中',
    out_for_delivery: '正在派送',
    exception: '派送未成功',
    delivered: '已送達',
    partial: '分批寄出'
  };

  var STATUS_BADGE_CLASS = {
    unfulfilled: 'han-order-tracking__badge--warning',
    collected: 'han-order-tracking__badge--info',
    in_transit: 'han-order-tracking__badge--info',
    out_for_delivery: 'han-order-tracking__badge--info',
    exception: 'han-order-tracking__badge--danger',
    delivered: 'han-order-tracking__badge--success',
    partial: 'han-order-tracking__badge--warning'
  };

  var CUSTOMER_TEXT_MAP = {
    '初始查詢': '準備查詢',
    '查詢中': '正在查詢',
    '找不到訂單': '未能找到訂單',
    '尚未出貨': '尚未寄出',
    '物流商已收件': '已交送貨公司',
    '運送途中': '運送中',
    '派送中': '正在派送',
    '派送異常': '派送未成功',
    '分批出貨': '分批寄出',
    '訂單確認': '訂單已確認',
    '出貨資料已建立': '已準備寄出',
    '物流更新': '送貨進度更新',
    '物流商待確認': '送貨公司待確認'
  };

  function createElement(tagName, className, text) {
    var element = document.createElement(tagName);

    if (className) {
      element.className = className;
    }

    if (typeof text === 'string') {
      element.textContent = text;
    }

    return element;
  }

  function clearElement(element) {
    while (element.firstChild) {
      element.removeChild(element.firstChild);
    }
  }

  function localiseCustomerText(value) {
    var text = String(value || '');

    if (CUSTOMER_TEXT_MAP[text]) {
      return CUSTOMER_TEXT_MAP[text];
    }

    return text
      .replace(/物流商/g, '送貨公司')
      .replace(/物流狀態/g, '送貨進度')
      .replace(/物流資料/g, '送貨資料')
      .replace(/物流事件/g, '送貨記錄')
      .replace(/出貨/g, '寄出');
  }

  function normaliseOrderNumber(value) {
    return String(value || '').trim().replace(/^#+/, '').replace(/[\s-]/g, '').toUpperCase();
  }

  function orderNumberMatches(source, query) {
    var sourceNumber = normaliseOrderNumber(source);
    var queryNumber = normaliseOrderNumber(query);

    if (sourceNumber === queryNumber) {
      return true;
    }

    if (/^\d+$/.test(queryNumber)) {
      return sourceNumber.replace(/\D/g, '') === queryNumber;
    }

    return false;
  }

  function normaliseEmail(value) {
    return String(value || '').trim().toLowerCase();
  }

  function normalisePhone(value) {
    var digits = String(value || '').replace(/\D/g, '');

    if (digits.indexOf('852') === 0 && digits.length === 11) {
      return digits.slice(3);
    }

    return digits;
  }

  function readMockData(root) {
    var script = root.querySelector('[data-order-tracking-mock]');

    if (!script) {
      return { orders: [] };
    }

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return { orders: [] };
    }
  }

  function createMockOrderTrackingAdapter(mockData) {
    var orders = Array.isArray(mockData.orders) ? mockData.orders : [];

    return {
      findOrder: function (query) {
        return new Promise(function (resolve) {
          window.setTimeout(function () {
            var orderNumber = normaliseOrderNumber(query.orderNumber);
            var verificationMethod = query.verificationMethod;
            var email = normaliseEmail(query.email);
            var phone = normalisePhone(query.phone);

            var order = orders.find(function (item) {
              if (!orderNumberMatches(item.orderNumber, orderNumber)) {
                return false;
              }

              if (verificationMethod === 'email') {
                return normaliseEmail(item.email) === email;
              }

              return normalisePhone(item.phone) === phone;
            });

            resolve(order || null);
          }, 650);
        });
      }
    };
  }

  function createApiOrderTrackingAdapter(endpoint) {
    return {
      findOrder: function (query) {
        return window.fetch(endpoint, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            order_number: normaliseOrderNumber(query.orderNumber),
            verification_method: query.verificationMethod,
            email: normaliseEmail(query.email),
            phone: normalisePhone(query.phone)
          })
        }).then(function (response) {
          if (response.status === 404) {
            return null;
          }

          if (!response.ok) {
            throw new Error('Order tracking request failed.');
          }

          return response.json();
        }).then(function (payload) {
          if (!payload) {
            return null;
          }

          return payload.order || payload;
        });
      }
    };
  }

  function createOrderTrackingAdapter(root) {
    var endpoint = String(root.dataset.apiEndpoint || '').trim();

    if (endpoint) {
      return createApiOrderTrackingAdapter(endpoint);
    }

    return createMockOrderTrackingAdapter(readMockData(root));
  }

  function parseDateValue(value) {
    var source = String(value || '').trim();
    var date;

    if (!source) {
      return null;
    }

    if (/^\d{4}-\d{2}-\d{2}$/.test(source)) {
      source += 'T00:00:00+08:00';
    } else if (/^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}$/.test(source)) {
      source = source.replace(' ', 'T') + ':00+08:00';
    }

    date = new Date(source);

    return Number.isNaN(date.getTime()) ? null : date;
  }

  function formatDate(value) {
    var date = parseDateValue(value);

    if (!date) {
      return value ? String(value) : '待確認';
    }

    return new Intl.DateTimeFormat('zh-HK', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: 'Asia/Hong_Kong'
    }).format(date);
  }

  function formatDateTime(value) {
    var date = parseDateValue(value);

    if (!date) {
      return value ? String(value) : '時間待確認';
    }

    return new Intl.DateTimeFormat('zh-HK', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZone: 'Asia/Hong_Kong'
    }).format(date);
  }

  function getStatusLabel(status) {
    return STATUS_LABELS[status] || '待確認';
  }

  function createBadge(status) {
    var badge = createElement('span', 'han-order-tracking__badge', getStatusLabel(status));
    var modifier = STATUS_BADGE_CLASS[status];

    if (modifier) {
      badge.classList.add(modifier);
    }

    return badge;
  }

  function setState(root, status) {
    var stateLabel = root.querySelector('[data-state-label]');

    if (stateLabel) {
      stateLabel.textContent = getStatusLabel(status);
    }
  }

  function setFormMessage(root, message) {
    var messageElement = root.querySelector('[data-form-message]');

    if (!messageElement) {
      return;
    }

    if (!message) {
      messageElement.hidden = true;
      messageElement.textContent = '';
      return;
    }

    messageElement.hidden = false;
    messageElement.textContent = message;
  }

  function setFieldInvalid(field, isInvalid) {
    if (!field) {
      return;
    }

    if (isInvalid) {
      field.setAttribute('aria-invalid', 'true');
    } else {
      field.removeAttribute('aria-invalid');
    }
  }

  function updateVerificationFields(root) {
    var selected = root.querySelector('[data-verification-method]:checked');
    var method = selected ? selected.value : 'email';
    var emailField = root.querySelector('[data-verification-field="email"]');
    var phoneField = root.querySelector('[data-verification-field="phone"]');
    var emailInput = root.querySelector('[data-email]');
    var phoneInput = root.querySelector('[data-phone]');

    if (emailField && phoneField && emailInput && phoneInput) {
      emailField.classList.toggle('is-hidden', method !== 'email');
      phoneField.classList.toggle('is-hidden', method !== 'phone');
      emailInput.required = method === 'email';
      phoneInput.required = method === 'phone';
      setFieldInvalid(emailInput, false);
      setFieldInvalid(phoneInput, false);
    }
  }

  function validateForm(root) {
    var orderInput = root.querySelector('[data-order-number]');
    var emailInput = root.querySelector('[data-email]');
    var phoneInput = root.querySelector('[data-phone]');
    var selected = root.querySelector('[data-verification-method]:checked');
    var method = selected ? selected.value : 'email';

    setFieldInvalid(orderInput, false);
    setFieldInvalid(emailInput, false);
    setFieldInvalid(phoneInput, false);

    if (!normaliseOrderNumber(orderInput.value)) {
      setFieldInvalid(orderInput, true);
      return {
        valid: false,
        message: '請輸入訂單編號。',
        focusTarget: orderInput
      };
    }

    if (method === 'email') {
      if (!normaliseEmail(emailInput.value)) {
        setFieldInvalid(emailInput, true);
        return {
          valid: false,
          message: '請輸入電郵地址。',
          focusTarget: emailInput
        };
      }

      if (emailInput.validity && !emailInput.validity.valid) {
        setFieldInvalid(emailInput, true);
        return {
          valid: false,
          message: '請輸入有效的電郵地址。',
          focusTarget: emailInput
        };
      }
    }

    if (method === 'phone' && normalisePhone(phoneInput.value).length < 8) {
      setFieldInvalid(phoneInput, true);
      return {
        valid: false,
        message: '請輸入有效的手提電話號碼。',
        focusTarget: phoneInput
      };
    }

    return {
      valid: true,
      query: {
        orderNumber: orderInput.value,
        verificationMethod: method,
        email: emailInput.value,
        phone: phoneInput.value
      }
    };
  }

  function setLoading(root, isLoading) {
    var submitButton = root.querySelector('[data-submit-button]');
    var results = root.querySelector('[data-order-tracking-results]');

    if (submitButton) {
      submitButton.disabled = isLoading;
      submitButton.textContent = isLoading ? '正在查詢' : '查詢訂單';
    }

    if (results) {
      results.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }
  }

  function renderLoading(root) {
    var results = root.querySelector('[data-order-tracking-results]');
    var loading = createElement('div', 'han-order-tracking__loading');
    var body = createElement('div');
    var spinner = createElement('div', 'han-order-tracking__spinner');
    var text = createElement('p', null, '正在查詢，請稍候。');

    if (!results) {
      return;
    }

    spinner.setAttribute('aria-hidden', 'true');
    body.appendChild(spinner);
    body.appendChild(text);
    loading.appendChild(body);
    clearElement(results);
    results.appendChild(loading);
  }

  function renderNotFound(root) {
    var results = root.querySelector('[data-order-tracking-results]');
    var wrapper = createElement('div', 'han-order-tracking__not-found');
    var heading = createElement('h2', null, '未能找到訂單');
    var body = createElement('p', null, '請檢查訂單編號，以及電郵地址或手提電話號碼是否正確。');

    if (!results) {
      return;
    }

    wrapper.appendChild(heading);
    wrapper.appendChild(body);
    clearElement(results);
    results.appendChild(wrapper);
    results.focus();
  }

  function createMetaItem(label, value) {
    var item = createElement('div');
    var term = createElement('dt', null, label);
    var description = createElement('dd', null, value || '待確認');

    item.appendChild(term);
    item.appendChild(description);

    return item;
  }

  function getCarrierText(order) {
    var carriers = (order.shipments || []).map(function (shipment) {
      return localiseCustomerText(shipment.carrier);
    }).filter(Boolean);

    if (!carriers.length) {
      return '待寄出後確認';
    }

    return carriers.filter(function (carrier, index) {
      return carriers.indexOf(carrier) === index;
    }).join('、');
  }

  function getTrackingNumberText(order) {
    var trackingNumbers = (order.shipments || []).map(function (shipment) {
      return shipment.trackingNumber;
    }).filter(Boolean);

    if (!trackingNumbers.length) {
      return '待寄出後確認';
    }

    return trackingNumbers.join('、');
  }

  function getSafeOfficialTrackingUrl(value, allowedDomain) {
    var source = String(value || '').trim();

    if (!source) {
      return '';
    }

    try {
      var url = new URL(source);
      var hostname = url.hostname.toLowerCase();

      if (url.protocol !== 'https:') {
        return '';
      }

      if (hostname === allowedDomain || hostname.endsWith('.' + allowedDomain)) {
        return url.href;
      }
    } catch (error) {
      return '';
    }

    return '';
  }

  function getCarrierTrackingDetails(shipment) {
    var carrier = String(shipment.carrier || '').trim().toLowerCase();
    var trackingNumber = String(shipment.trackingNumber || '').trim();
    var isSf = carrier.indexOf('順豐') !== -1 ||
      carrier.indexOf('顺丰') !== -1 ||
      carrier.indexOf('sf express') !== -1 ||
      /^sf/i.test(trackingNumber);
    var isJd = carrier.indexOf('京東') !== -1 ||
      carrier.indexOf('京东') !== -1 ||
      carrier.indexOf('jd logistics') !== -1 ||
      carrier.indexOf('jd express') !== -1 ||
      /^jd/i.test(trackingNumber);
    var officialUrl;

    if (!trackingNumber) {
      return null;
    }

    if (isSf) {
      officialUrl = getSafeOfficialTrackingUrl(
        'https://hk.sf-express.com/hk/tc/waybill/waybill-detail/' + encodeURIComponent(trackingNumber),
        'sf-express.com'
      );

      return {
        carrierName: '順豐',
        url: officialUrl
      };
    }

    if (isJd) {
      officialUrl = getSafeOfficialTrackingUrl(
        'https://www.jdl.com/zh-HK/orderSearch/?waybillCodes=' + encodeURIComponent(trackingNumber),
        'jdl.com'
      );

      return {
        carrierName: '京東',
        url: officialUrl
      };
    }

    return null;
  }

  function createCarrierTrackingLink(shipment) {
    var details = getCarrierTrackingDetails(shipment);
    var trackingNumber = String(shipment.trackingNumber || '').trim();
    var link;

    if (!details) {
      return null;
    }

    link = createElement('a', 'han-order-tracking__carrier-link', '到' + details.carrierName + '官網查件');
    link.href = details.url;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.setAttribute('aria-label', '到' + details.carrierName + '官網查件，追蹤編號 ' + trackingNumber + '（另開新分頁）');

    return link;
  }

  function renderProgress(shipment) {
    var progress = createElement('ol', 'han-order-tracking__progress');
    var steps = Array.isArray(shipment.progress) ? shipment.progress : [];
    var currentStep = Number.isInteger(shipment.currentStep) ? shipment.currentStep : 0;

    progress.setAttribute('aria-label', '送貨進度');

    steps.forEach(function (step, index) {
      var item = createElement('li', 'han-order-tracking__progress-step');
      var dot = createElement('span', 'han-order-tracking__progress-dot', index <= currentStep ? '✓' : '');
      var label = createElement('span', null, localiseCustomerText(step));

      if (index < currentStep) {
        item.classList.add('is-complete');
      }

      if (index === currentStep) {
        item.classList.add('is-current');
      }

      dot.setAttribute('aria-hidden', 'true');
      item.appendChild(dot);
      item.appendChild(label);
      progress.appendChild(item);
    });

    return progress;
  }

  function renderTimeline(shipment) {
    var wrapper = createElement('div');
    var heading = createElement('h4', 'han-order-tracking__shipment-title', '送貨記錄');
    var timeline = createElement('ol', 'han-order-tracking__timeline');
    var events = Array.isArray(shipment.events) ? shipment.events : [];

    wrapper.appendChild(heading);

    if (!events.length) {
      wrapper.appendChild(createElement('p', null, '暫時未有送貨記錄。'));
      return wrapper;
    }

    events.forEach(function (event) {
      var item = createElement('li', 'han-order-tracking__timeline-item');
      var parsedTime = parseDateValue(event.time);
      var time = createElement('time', 'han-order-tracking__timeline-time', formatDateTime(event.time));
      var title = createElement('div', 'han-order-tracking__timeline-title', localiseCustomerText(event.title || '送貨進度更新'));
      var description = createElement('div', 'han-order-tracking__timeline-description', localiseCustomerText(event.description || '送貨公司已更新進度。'));

      if (parsedTime) {
        time.dateTime = parsedTime.toISOString();
      }

      item.appendChild(time);
      item.appendChild(title);
      item.appendChild(description);
      timeline.appendChild(item);
    });

    wrapper.appendChild(timeline);

    return wrapper;
  }

  function renderShipment(shipment, index, total) {
    var section = createElement('section', 'han-order-tracking__shipment');
    var header = createElement('div', 'han-order-tracking__shipment-header');
    var carrierName = localiseCustomerText(shipment.carrier || '送貨公司待確認');
    var titleText = total > 1 ? '包裹 ' + (index + 1) + '：' + carrierName : carrierName;
    var title = createElement('h3', 'han-order-tracking__shipment-title', titleText);
    var trackingRow = createElement('div', 'han-order-tracking__tracking-number');
    var trackingNumber = shipment.trackingNumber || '';

    header.appendChild(title);
    header.appendChild(createBadge(shipment.status));

    if (trackingNumber) {
      var code = createElement('code', null, trackingNumber);
      var copyButton = createElement('button', 'han-order-tracking__copy', '複製追蹤編號');
      var copyStatus = createElement('span', 'han-order-tracking__copy-status');
      var carrierLink = createCarrierTrackingLink(shipment);

      copyButton.type = 'button';
      copyButton.dataset.copyTracking = trackingNumber;
      copyButton.setAttribute('aria-label', '複製追蹤編號 ' + trackingNumber);
      copyStatus.setAttribute('aria-live', 'polite');

      trackingRow.appendChild(code);
      trackingRow.appendChild(copyButton);

      if (carrierLink) {
        trackingRow.appendChild(carrierLink);
      }

      trackingRow.appendChild(copyStatus);
    } else {
      trackingRow.appendChild(createElement('span', null, '追蹤編號：待寄出後確認'));
    }

    section.appendChild(header);
    section.appendChild(trackingRow);

    if (Array.isArray(shipment.progress) && shipment.progress.length) {
      section.appendChild(renderProgress(shipment));
    }

    section.appendChild(renderTimeline(shipment));

    return section;
  }

  function renderUnfulfilledTimeline() {
    var wrapper = createElement('section', 'han-order-tracking__shipment');
    var heading = createElement('h3', 'han-order-tracking__shipment-title', '送貨記錄');
    var body = createElement('p', null, '訂單寄出後，送貨進度會顯示在這裡。');

    wrapper.appendChild(heading);
    wrapper.appendChild(body);

    return wrapper;
  }

  function renderOrder(root, order) {
    var results = root.querySelector('[data-order-tracking-results]');
    var summary = createElement('div', 'han-order-tracking__summary');
    var header = createElement('div', 'han-order-tracking__summary-header');
    var statusRow = createElement('div', 'han-order-tracking__status-row');
    var heading = createElement('h2', null, '訂單 ' + normaliseOrderNumber(order.orderNumber));
    var meta = createElement('dl', 'han-order-tracking__meta');
    var shipments = Array.isArray(order.shipments) ? order.shipments : [];

    if (!results) {
      return;
    }

    statusRow.appendChild(createElement('span', null, '最新狀態'));
    statusRow.appendChild(createBadge(order.status));
    header.appendChild(heading);
    header.appendChild(statusRow);
    summary.appendChild(header);

    meta.appendChild(createMetaItem('最新狀態', getStatusLabel(order.status)));
    meta.appendChild(createMetaItem('預計送達', formatDate(order.estimatedDelivery)));
    meta.appendChild(createMetaItem('送貨公司', getCarrierText(order)));
    meta.appendChild(createMetaItem('追蹤編號', getTrackingNumberText(order)));
    summary.appendChild(meta);

    if (order.note) {
      summary.appendChild(createElement('p', 'han-order-tracking__note', localiseCustomerText(order.note)));
    }

    if (shipments.length) {
      shipments.forEach(function (shipment, index) {
        summary.appendChild(renderShipment(shipment, index, shipments.length));
      });
    } else {
      summary.appendChild(renderUnfulfilledTimeline());
    }

    clearElement(results);
    results.appendChild(summary);
    results.focus();
  }

  function copyText(value) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(value);
    }

    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');

      textarea.value = value;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.top = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        document.execCommand('copy');
        resolve();
      } catch (error) {
        reject(error);
      } finally {
        document.body.removeChild(textarea);
      }
    });
  }

  function handleCopy(event) {
    var button = event.target.closest('[data-copy-tracking]');

    if (!button) {
      return;
    }

    var status = button.parentElement.querySelector('.han-order-tracking__copy-status');
    var originalLabel = button.textContent;

    copyText(button.dataset.copyTracking).then(function () {
      button.textContent = '已複製';

      if (status) {
        status.textContent = '追蹤編號已複製。';
      }

      window.setTimeout(function () {
        button.textContent = originalLabel;
      }, 1800);
    }).catch(function () {
      if (status) {
        status.textContent = '複製失敗，請手動選取追蹤編號。';
      }
    });
  }

  function initOrderTracking(root) {
    var form = root.querySelector('[data-order-tracking-form]');
    var adapter = createOrderTrackingAdapter(root);

    if (!form) {
      return;
    }

    setState(root, 'initial');
    updateVerificationFields(root);

    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-verification-method]')) {
        updateVerificationFields(root);
        setFormMessage(root, '');
      }
    });

    root.addEventListener('click', handleCopy);

    form.addEventListener('submit', function (event) {
      var validation;

      event.preventDefault();
      setFormMessage(root, '');
      validation = validateForm(root);

      if (!validation.valid) {
        setFormMessage(root, validation.message);
        validation.focusTarget.focus();
        return;
      }

      setState(root, 'loading');
      setLoading(root, true);
      renderLoading(root);

      adapter.findOrder(validation.query).then(function (order) {
        setLoading(root, false);

        if (!order) {
          setState(root, 'not_found');
          renderNotFound(root);
          return;
        }

        setState(root, order.status);
        renderOrder(root, order);
      }).catch(function () {
        setLoading(root, false);
        setState(root, 'initial');
        setFormMessage(root, '暫時未能查詢訂單，請稍後再試。');
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-order-tracking]').forEach(initOrderTracking);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
